import {FC, ReactElement, useCallback, useEffect, useState} from "react";
import globalAxios from "axios";
import { defaultConfig } from "./utils";
import { IConfig } from "./types";
import { LoaderWrapper } from "../../components";
import { ApiStatuses } from "../../app/types";
import { ConfigContext } from "./context";
import { useTranslation } from "react-i18next";
import { axios } from "../axios";
import * as Sentry from "@sentry/react";

interface Props {
  children: ReactElement;
}

export const ConfigContainer: FC<Props> = ({ children }) => {
  const [config, setConfig] = useState<IConfig | undefined>();
  const { i18n } = useTranslation();

  const handleSetConfig = (config: IConfig) => {
    void i18n.changeLanguage(config.language);
    axios.defaults.baseURL = config.apiUrl;
    const isProduction = config.env === "production";
    Sentry.setTag("Production", isProduction);
    setConfig(config);
  };

  const handleFetchConfig = useCallback(async () => {
    if (config) return;
    try {
      const configResponse = await globalAxios.get("/config.json");
      console.log("configResponse", configResponse);
      if (configResponse.status !== 200) {
        handleSetConfig(defaultConfig);
        return;
      }

      const configData = configResponse.data as Partial<IConfig>;

      console.log("configData", configData);

      const apiUrl = configData.apiUrl || defaultConfig.apiUrl;
      const authDomain = configData.authDomain || defaultConfig.authDomain;
      const clientId = configData.clientId || defaultConfig.clientId;
      const organization = configData.organization || defaultConfig.organization;
      const language = configData.language || defaultConfig.language;
      const env = configData.env || defaultConfig.env;

      console.log("authDomain", authDomain);
      console.log("clientId", clientId);
      console.log("organization", organization);
      console.log("language", language);
      console.log("env", env);

      handleSetConfig({
        authDomain,
        clientId,
        organization,
        language,
        env,
        apiUrl,
      });
    } catch (error) {
      handleSetConfig(defaultConfig);
    }
  }, [config]);

  useEffect(() => {
    void handleFetchConfig();
  }, [handleFetchConfig]);

  return (
    <ConfigContext.Provider value={config as IConfig}>
      <LoaderWrapper
        status={config ? ApiStatuses.success : ApiStatuses.loading}
      >
        {children}
      </LoaderWrapper>
    </ConfigContext.Provider>
  );
};
